module.exports = __webpack_public_path__ + "static/media/expandArrowsWhite1.340a5785.png";